<template>
    <div class="modal fade" ref="progressModal" data-keyboard="false" data-backdrop="static" id="progress-modal" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Asset Upload Progress</h5>
                </div>
                <div class="modal-body">
                    <div class="progress">
                        <div class="progress-bar" role="progressbar" :style="{width: `${uploadProgress}%`}" :aria-valuenow="uploadProgress" aria-valuemin="0" aria-valuemax="100">{{ uploadProgress }}%</div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button @click="cancelUpload" type="button" class="btn btn-primary" data-dismiss="modal">Cancel Upload</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        uploadProgress: {
            type: Number,
            default: 0
        },
        open: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        $(this.$refs.progressModal).on('shown.bs.modal', () => {
            if (this.uploadProgress === 100) {
                $(this.$refs.progressModal).modal('hide');
            }
        })
    },
    watch: {
        open(newValue) {
            if (!newValue) {
                $(this.$refs.progressModal).modal('hide');
            } else {
                $(this.$refs.progressModal).modal('show');
            }
        }
    },
    methods: {
        cancelUpload() {
            this.$emit('uploadCanceled');
        }
    }
}
</script>
